import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { TdPriceComponent } from "./td-price.component";
import { MatTableModule } from "@angular/material/table";
import { PriceModule } from "libraries/component/price/price.module";
import { CurrencyModule } from "libraries/service/currency/currency.module";

@NgModule({
 imports: [
     CommonModule,
     MatTableModule,
     PriceModule,
     CurrencyModule,
 ],
 exports: [
     TdPriceComponent,
 ],
 declarations: [
     TdPriceComponent,
 ],
 providers: [],
})
export class TdPriceModule { }
